import { c as _c } from "react/compiler-runtime";
import { Checkbox, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { nounPluralize } from "@utils/data-display";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
/** What enabling group creation lets the members do, e.g. below the checkbox in a group invite */
export const GROUP_CREATION_DESCRIPTION = "Lets them create new groups in this workspace.";
/**
 * Checkbox to enable the user to create groups.
 * It is only shown if the selected role is a group manager
 * and the current user has the permission edit members.
 */
export function EnableGroupCreationCheckbox(t0) {
  const $ = _c(18);
  const {
    selectedRole,
    shouldCreateGroups,
    membersCount,
    setShouldCreateGroups,
    isDisabled: t1,
    description
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  const {
    canEditMember
  } = useHasUserValidRoleCompanyLevel();
  if (selectedRole !== "COMPANY_MANAGER" || !canEditMember) {
    return null;
  }
  let t2;
  if ($[0] !== setShouldCreateGroups || $[1] !== shouldCreateGroups) {
    t2 = () => setShouldCreateGroups(!shouldCreateGroups);
    $[0] = setShouldCreateGroups;
    $[1] = shouldCreateGroups;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      mt: 1.25
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== membersCount) {
    t4 = nounPluralize({
      shouldShowCounter: false,
      counter: membersCount,
      word: "this user"
    });
    $[4] = membersCount;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `Enable ${t4} to create groups`;
  let t6;
  if ($[6] !== t5) {
    t6 = <span>{t5}</span>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== description) {
    t7 = description && <Text variant="bodyS" component="span" sx={{
      color: "text.secondary"
    }}>{description}</Text>;
    $[8] = description;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <Stack component="span">{t6}{t7}</Stack>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== isDisabled || $[14] !== shouldCreateGroups || $[15] !== t2 || $[16] !== t8) {
    t9 = <Checkbox checked={shouldCreateGroups} disabled={isDisabled} onChange={t2} controlSx={t3} label={t8} />;
    $[13] = isDisabled;
    $[14] = shouldCreateGroups;
    $[15] = t2;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}